import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      currentCompany: '',
      form: {
        name: '',
        contractNumber: '',
      },
      rules: {
        name: [
          { required: true, message: "Назва є обов'язковою" },
        ],
        contractNumber: [
          { required: true, message: "Номер договору є обов'язковим" }
        ]
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      currCompany: state => state.Auth.currentCompany,
      companies: (state) => {
        return state.Auth.companies;
      },
    }),
    ...mapGetters([
      'isAdmin'
    ]),
  },
  methods: {
    ...mapActions(['logout', 'addCompany', 'getCompanies', 'setCurrentCompany']),
    logoutHandler() {
      this.logout().then(() => {
        this.$router.push('/login');
      });
    },
    popoverShow() {
      this.getCompanies();
    },
    handleClose() {},
    openAddAccount() {
      this.dialogVisible = true;
    },
    changeCompany(val) {
      this.setCurrentCompany(val);
    },
    addNewCompany() {
      this.$refs.addCompanyForm.validate((valid) => {
        if (valid) {
          let company = {
            company: {
              name: this.form.name,
              contractNumber: this.form.contractNumber,
            },
          };
          this.addCompany(company)
            .then((response) => {
              this.dialogVisible = false;
              this.$notify.success({
                title: 'Success',
                message: response.data,
              });
            })
            .catch((error) => {
              this.$notify.error({
                title: 'Error',
                message: error.response.data,
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
